<template>
	<div>
		<component :is="componentId" :fetchedData="fetchedData" :block="block" />
	</div>
</template>

<script>

export default {
	name: 'PanelComponentBlock',
	components: {
		campus: () => import('~/components/static/campus.vue'),
		campusEng: () => import('~/components/static/campusEng.vue'),
		SchoolAbout: () => import('~/components/static/SchoolAbout.vue'),
		SchoolProgress: () => import('~/components/static/SchoolProgress.vue'),
		PartnersOverview: () => import('~/components/static/PartnersOverview.vue'),
		PanelSolutions: () => import('~/components/static/PanelSolutions.vue'),
		PanelMainPartnersDescription: () => import('~/components/static/PanelMainPartnersDescription.vue'),
		PanelMainSpeakersNights: () => import('~/components/static/PanelMainSpeakersNights.vue'),
		PanelMainSpeakersNights2: () => import('~/components/static/PanelMainSpeakersNights2.vue'),
		PanelMainSpeakersNights3: () => import('~/components/static/PanelMainSpeakersNights3.vue'),

		PanelNav02: () => import('~/components/panels/NAV/PanelNav02.vue'),


		PanelManagmentText: () => import('~/components/static/PanelManagmentText.vue'),
		SchoolHistory: () => import('~/components/static/SchoolHistory.vue'),
		SchoolHistoryDetail: () => import('~/components/static/SchoolHistoryDetail.vue'),
		SchoolAccreditation: () => import('~/components/static/SchoolAccreditation.vue'),
		SchoolSustainability: () => import('~/components/static/SchoolSustainability.vue'),
		MonitoringSubscribe: () => import('~/components/static/MonitoringSubscribe.vue'),

		SchoolCampusFacts: () => import('~/components/static/SchoolCampusFacts.vue'),
		SchoolContactsBuses: () => import('~/components/static/SchoolContactsBuses.vue'),

		PanelContacts: () => import('~/components/static/PanelContacts.vue'),
		PanelContactsShort: () => import('~/components/static/PanelContactsShort.vue'),


		IssueAnnounces: () => import('~/components/blocks/issue/IssueAnnounces.vue'),
		IssueAnnouncesSimple: () => import('~/components/blocks/issue/IssueAnnouncesSimple.vue'),

		ProgramWithPictures: () => import('~/components/static/ProgramWithPictures.vue'),

		PanelProgramResume: () => import('~/components/static/PanelProgramResume.vue'),
		StaticPriceSingle: () => import('~/components/static/StaticPriceSingle.vue'),

		PanelDigitSteps: () => import('~/components/static/PanelDigitSteps.vue'),

		// PanelExtProgram: () => import('~/components/static/PanelExtProgram.vue'),

		PanelCorporateStages: () => import('~/components/static/PanelCorporateStages.vue'),
		PanelCorporateAward: () => import('~/components/static/PanelCorporateAward.vue'),
		PanelCorporateParticipant: () => import('~/components/static/PanelCorporateParticipant.vue'),
		PanelCorporateReview: () => import('~/components/static/PanelCorporateReview.vue'),
		PanelCorporateThemesTable: () => import('~/components/static/PanelCorporateThemesTable.vue'),

		PanelCorporateHeadImage: () => import('~/components/static/PanelCorporateHeadImage.vue'),
		PanelCorporateTeaserTrend: () => import('~/components/static/PanelCorporateTeaserTrend.vue'),


		PanelCorporateLeadMain: () => import('~/components/static/PanelCorporateLeadMain.vue'),
		PanelCorporateLeadThemes: () => import('~/components/static/PanelCorporateLeadThemes.vue'),
		PanelCorporateLeadCases: () => import('~/components/static/PanelCorporateLeadCases.vue'),
		PanelCorporateLeadTeam: () => import('~/components/static/PanelCorporateLeadTeam.vue'),

		PanelCorporateCardThemes: () => import('~/components/static/PanelCorporateCardThemes.vue'),
		PanelCorporateDigits: () => import('~/components/static/PanelCorporateDigits.vue'),


		CampusAbout: () => import('~/components/static/CampusAbout.vue'),
		CampusContacts: () => import('~/components/static/CampusContacts.vue'),
		CampusHotelsList: () => import('~/components/static/CampusHotelsList.vue'),
		CampusAuditoriesList: () => import('~/components/static/CampusAuditoriesList.vue'),
		CampusPandemicInfo: () => import('~/components/static/CampusPandemicInfo.vue'),

		// Верстка новых блоков (закрытая зона)
		DraftHeaderCourse: () => import('~/components/static/DraftHeaderCourse.vue'),
		DraftHeaderCourse2: () => import('~/components/static/DraftHeaderCourse2.vue'),
		DraftHeaderArticle: () => import('~/components/static/DraftHeaderArticle.vue'),
		DraftHeaderWebinar: () => import('~/components/static/DraftHeaderWebinar.vue'),
		DraftHeaderWebinar2: () => import('~/components/static/DraftHeaderWebinar2.vue'),
		DraftHeaderWebinar3: () => import('~/components/static/DraftHeaderWebinar3.vue'),

		DraftAbout1: () => import('~/components/static/DraftAbout1.vue'),
		DraftAbout2: () => import('~/components/static/DraftAbout2.vue'),
		DraftAbout3: () => import('~/components/static/DraftAbout3.vue'),
		DraftAbout4: () => import('~/components/static/DraftAbout4.vue'),
		DraftAbout5: () => import('~/components/static/DraftAbout5.vue'),

		DraftHeading1: () => import('~/components/static/DraftHeading1.vue'),
		DraftHeading2: () => import('~/components/static/DraftHeading2.vue'),
		DraftHeading3: () => import('~/components/static/DraftHeading3.vue'),
		DraftHeading4: () => import('~/components/static/DraftHeading4.vue'),
		DraftHeading5: () => import('~/components/static/DraftHeading5.vue'),

		DraftKeyphrase1: () => import('~/components/static/DraftKeyphrase1.vue'),
		DraftKeyphrase2: () => import('~/components/static/DraftKeyphrase2.vue'),
		DraftKeyphrase3: () => import('~/components/static/DraftKeyphrase3.vue'),
		DraftKeyphrase4: () => import('~/components/static/DraftKeyphrase4.vue'),
		DraftKeyphrase5: () => import('~/components/static/DraftKeyphrase5.vue'),

		DraftWhywe1: () => import('~/components/static/DraftWhywe1.vue'),
		DraftWhywe2: () => import('~/components/static/DraftWhywe2.vue'),
		// DraftWhywe3: () => import('~/components/static/DraftWhywe3.vue'),
		DraftWhywe4: () => import('~/components/static/DraftWhywe4.vue'),
		DraftWhywe5: () => import('~/components/static/DraftWhywe5.vue'),
		DraftWhywe5_1: () => import('~/components/static/DraftWhywe5_1.vue'),
		DraftWhywe6: () => import('~/components/static/DraftWhywe6.vue'),

		DraftReview1: () => import('~/components/static/DraftReview1.vue'),

		DraftCards1: () => import('~/components/static/DraftCards1.vue'),
		DraftCards1_1: () => import('~/components/static/DraftCards1_1.vue'),
		DraftCards1_2: () => import('~/components/static/DraftCards1_2.vue'),
		DraftCards4: () => import('~/components/static/DraftCards4.vue'),
		DraftCards5: () => import('~/components/static/DraftCards5.vue'),
		DraftCards6: () => import('~/components/static/DraftCards6.vue'),

		DraftSteps1: () => import('~/components/static/DraftSteps1.vue'),
		DraftSteps2: () => import('~/components/static/DraftSteps2.vue'),
		DraftSteps2_1: () => import('~/components/static/DraftSteps2_1.vue'),
		DraftSteps3: () => import('~/components/static/DraftSteps3.vue'),

		PanelMpsSpeakers: () => import('~/components/static/PanelMpsSpeakers.vue'),
	},

	inheritAttrs: false,
	props: {
		block: { type: Object, required: true },
		index: { type: Number, required: true },
		fetchedData: { type: Object, required: true },
	},
	computed: {
		componentId() {
			if (!this.block.content) return null;
			return this.block.content.component;
		},
	},
};
</script>
